export default "__VITE_ASSET__5e96149f__"